import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';

export default function Reference() {
    const { t } = useLang('Reference');
    const { locale } = getLocal();

    const text = `* Whole-Home：Refers to the capability to power household appliances-including a 5-ton A/C (based on internal testing). Actual coverage and runtime vary with loads, battery/PV availability, and site conditions.
* 100% Whole-Home Power：Refers to the capability to power household appliances--including a 5-ton (based on internal testing). Actual coverage and runtime vary with loads, battery/PV availability, and site conditions.
* 12kW-36kW output&12kWh-180kWh：capacity.Performance figures are based on the recommended standard bundle configuraon (1 x EcoFlow DELTA Pro Ultra X Inverter + 2 x EcoFlowDELTA Pro Ultra X Batteries). Maximum rated output (36kW) and capacity (18Wh) require system expansion with three EcoFlow DELTA Pro Ultra X Inverter and ten batteries per inverter. Actual output andcapacity depend on the number of battery packs and system setup.
`;

    return (
        <div className={`${styles.Reference} GtmModuleData-section`}>
            <div className="pb-layout footer-desc">{text}</div>
        </div>
    );
}
